import React, { useRef } from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import {
  createBrowserRouter,
  RouterProvider,
  Outlet
} from "react-router-dom";
import { AuthProvider } from './client/context/AuthContext';
import { TimerProvider } from './client/context/TimerContext';
import { AdminAuthProvider } from './admin/context/AdminAuthContext';
// Client
import ProtectedRoute from './client/components/ProtectedRoute';
import Home from './client/routes/Home';
import Login from './client/routes/LoginClient';
import Psikotes from './client/routes/Psikotes';
import PsikotesResult from './client/routes/PsikotesResult';
// Admin
import AdminProtectedRoute from './admin/component/AdminProtectedRoute';
import Layout from './admin/layout/Layout';
import LoginAdmin from './admin/routes/LoginAdmin';
import Dashboard from './admin/routes/Dashboard';
import ManageUser from './admin/routes/ManageUser';
import Result from './admin/routes/Result';
import Detail from './admin/routes/DetailRes';

const App = () => {
  const handleSubmitRef = useRef(null);
  const AuthLayout = () => (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );

  const AdminAuthLayout = () => (
    <AdminAuthProvider>
      <Outlet />
    </AdminAuthProvider>
  );

  const router = createBrowserRouter([
    {
      path: '/',
      element: <AuthLayout />,
      children: [
        { path: '/', element: <Login /> },
        {
          path: '/home',
          element: (
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          )
        },
        {
          path: '/psikotes/:psikotesId',
          element: (
            <ProtectedRoute>
              <TimerProvider initialTime={15} onTimeUp={() => handleSubmitRef.current()}>
                <Psikotes handleSubmitRef={handleSubmitRef} />
              </TimerProvider>
            </ProtectedRoute>
          )
        },
        {
          path: '/psikotesResult/:psikotesId/:user/:resultId',
          element: (
            <ProtectedRoute>
              <PsikotesResult />
            </ProtectedRoute>
          )
        },
      ]
    },
    {
      path: '/adminJaya',
      element: <AdminAuthLayout />,
      children: [
        { path: '', element: <LoginAdmin /> },
        {
          path: '',
          element: (
            <AdminProtectedRoute>
              <Layout />
            </AdminProtectedRoute>
          ),
          children: [
            { path: 'dashboard', element: <Dashboard /> },
            { path: 'manageUser', element: <ManageUser /> },
            { path: 'resultPsikotesUser', element: <Result /> },
            { path: 'detailRes/:psychTestId/:uid/:resultId', element: <Detail /> } 
          ]
        }
      ]
    }
  ]);

  return (
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(<App />);